import { HeaderProps } from '../../../src/entities/header';

const HIDE_QUOTE_BAR_PREFIXES = ['/account'] as const;

const matchesPrefix = (pathname: string, prefix: string) => pathname === prefix || pathname.startsWith(`${prefix}/`);

const isQuotePath = (pathname: string) => pathname === '/quote' || pathname.startsWith('/quote/');

export function getChromeConfig(pathname: string): HeaderProps {
  if (isQuotePath(pathname)) {
    return {
      showHeaderDisplayAd: true,
      showRotatingBanner: false,
    };
  }

  if (pathname === '/') {
    return {
      showRotatingBanner: true,
    };
  }

  if (pathname === '/logout') {
    return {
      hideBanner: true,
      hideQuoteBar: true,
    };
  }

  if (pathname.startsWith('/money/preview/')) {
    return {
      hideBanner: true,
      hideQuoteBar: true,
      hideSearchBar: true,
      isMainDrawerVisible: true,
    };
  }

  if (pathname.startsWith('/applications/')) {
    return {
      hideBanner: true,
      hideQuoteBar: true,
    };
  }

  if (pathname.startsWith('/author/')) {
    return {
      hideBanner: true,
      hideMenuBar: true,
      hideQuoteBar: true,
      hideSearchBar: true,
      isMainDrawerVisible: true,
    };
  }

  if (HIDE_QUOTE_BAR_PREFIXES.some(prefix => matchesPrefix(pathname, prefix))) {
    return { hideQuoteBar: true };
  }

  if (pathname === '/services') {
    return { sticky: false, showRotatingBanner: false, showHeaderDisplayAd: false };
  }

  return {};
}

export function applyChromeConfig(pathname: string, headerProps: HeaderProps): HeaderProps {
  const chrome = getChromeConfig(pathname);
  const hideQuoteBar =
    chrome.hideQuoteBar ??
    (HIDE_QUOTE_BAR_PREFIXES.some(prefix => matchesPrefix(pathname, prefix)) ? true : headerProps.hideQuoteBar);

  const showRotatingBanner =
    chrome.showRotatingBanner ??
    (typeof headerProps.showRotatingBanner === 'boolean' ? headerProps.showRotatingBanner : false);

  const showHeaderDisplayAd = showRotatingBanner
    ? false
    : (chrome.showHeaderDisplayAd ??
      chrome.showHeaderBanner ??
      chrome.showRaptiveBanner ??
      headerProps.showHeaderDisplayAd ??
      headerProps.showHeaderBanner ??
      headerProps.showRaptiveBanner ??
      true);

  const expandedHeaderDisplayAd =
    chrome.expandedHeaderDisplayAd ??
    chrome.expandedHeaderBanner ??
    chrome.raptiveExpandedHeader ??
    headerProps.expandedHeaderDisplayAd ??
    headerProps.expandedHeaderBanner ??
    headerProps.raptiveExpandedHeader;

  return {
    ...headerProps,
    hideBanner: chrome.hideBanner ?? false,
    hideFooter: chrome.hideFooter ?? headerProps.hideFooter,
    hideMenuBar: chrome.hideMenuBar ?? false,
    hideNavigationBar: chrome.hideNavigationBar ?? headerProps.hideNavigationBar,
    hideQuoteBar: hideQuoteBar ?? false,
    hideSearchBar: chrome.hideSearchBar,
    isMainDrawerVisible: chrome.isMainDrawerVisible,
    navigationLogoVariant: chrome.navigationLogoVariant ?? headerProps.navigationLogoVariant ?? 'default',
    sticky: chrome.sticky ?? headerProps.sticky ?? true,
    showRotatingBanner,
    showHeaderDisplayAd,
    // Keep legacy aliases populated for older Header / money call sites.
    showHeaderBanner: showHeaderDisplayAd,
    showRaptiveBanner: showHeaderDisplayAd,
    expandedHeaderDisplayAd,
    expandedHeaderBanner: expandedHeaderDisplayAd,
    raptiveExpandedHeader: expandedHeaderDisplayAd,
  };
}
